import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { smartProfileApiWithTimeout } from '~/api/smartProfile';

type Payload = {
  platform: string;
  handle: string;
};

type SearchResponse = {
  accountsFound: SmartAccountsType[];
};

export type SmartAccountsType = {
  platform: string;
  handle: string;
  profilePictureUrl: string | undefined;
  name: string;
  followersCount: number | undefined;
  type?: string;
};

// whalar-mode flow also make use of this hook
// please be aware in case any changes are done
export const useSearchSmartProfiles = () => {
  return useMutation<SmartAccountsType[], AxiosError, Payload, SearchResponse>(
    (payload) => {
      return smartProfileApiWithTimeout
        .post('/smart-profiles/platforms-search', { ...payload })
        .then((response) => {
          const { data } = response;
          return data.accountsFound;
        });
    },
    {
      retryDelay: 3000,
    },
  );
};
